import { render, staticRenderFns } from "./ShiftForm.vue?vue&type=template&id=5161faed&scoped=true"
import script from "./ShiftForm.vue?vue&type=script&lang=js"
export * from "./ShiftForm.vue?vue&type=script&lang=js"
import style0 from "./ShiftForm.vue?vue&type=style&index=0&id=5161faed&prod&scoped=true&lang=css"
import style1 from "./ShiftForm.vue?vue&type=style&index=1&id=5161faed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5161faed",
  null
  
)

export default component.exports